import i18n from '@/utils/i18n';
import React from 'react';
import { COMPOSER_PADDING_VERTICAL, MIN_COMPOSER_HEIGHT } from './constants';
import { ComposerProps } from 'react-native-gifted-chat';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import { Key } from '@platform/shortcuts/utils/keyboard-platform';
import { Platform, TextInput, View } from 'react-native';

type Props = ComposerProps & {
  isSendDisabled: boolean;
};

export const ChatComposer: React.FC<Props> = ({
  composerHeight = MIN_COMPOSER_HEIGHT,
  isSendDisabled,
  onInputSizeChanged,
  onTextChanged,
  text,
  ...rest
}) => {
  const [styles, theme] = useStyles();
  return (
    <View style={styles.base}>
      <TextInput
        multiline
        onChangeText={onTextChanged}
        onContentSizeChange={(e) => {
          const { contentSize } = e.nativeEvent;
          if (contentSize && onInputSizeChanged) {
            onInputSizeChanged(contentSize);
          }
        }}
        onKeyPress={(event) => {
          // send message and avoid adding newline when physical enter key is pressed
          if (event.nativeEvent.key === Key.Enter && Platform.OS === 'web') {
            if (!isSendDisabled && text?.trim()) {
              // onSend is passed to this component but react-native-gifted-chat
              // doesn't include it in the composer prop types
              // @ts-ignore
              rest.onSend({ text }, true);
            }

            event.preventDefault();
          }
        }}
        placeholder={i18n.t('type_message')}
        placeholderTextColor={theme.sk.color.text.hint}
        selectionColor={theme.colors.accent}
        style={[styles.textInput, { height: composerHeight }]}
        testID="chat-text-input"
        value={text}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    backgroundColor: theme.colors.background,
    borderRadius: 20,
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: COMPOSER_PADDING_VERTICAL,
  },
  textInput: {
    ...FONTS.primary,
    color: theme.sk.color.text.primary,
    fontSize: theme.fontSizes.medium,
    paddingTop: 0,
    ...Platform.select({
      android: { paddingBottom: 0 },
      web: { outlineWidth: 0 },
    }),
  },
}));
